module.exports = __webpack_public_path__ + "img/m2.1d9ec6f2.png";